import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import { useAuth } from "../contexts/auth-context";

interface RefineAuthWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper that uses the auth context instead of making its own API calls
 */
const RefineAuthWrapper: React.FC<RefineAuthWrapperProps> = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If not authenticated and not on login page, redirect to login
    if (!isAuthenticated && !isLoading && window.location.pathname !== "/login") {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading screen while checking authentication
  if (isLoading) {
    return <LoadingScreen message="Vérification de l'authentification..." />;
  }

  // Show loading screen while redirecting
  if (!isAuthenticated && window.location.pathname !== "/login") {
    return <LoadingScreen message="Redirection vers la page de connexion..." />;
  }

  return <>{children}</>;
};

export default RefineAuthWrapper;
